import React from 'react';
import { observer } from 'mobx-react';

import { TableSection } from 'apps/productQuote/ProductQuoteTables/TableSection';
import { clientStore } from 'apps/client/app';
import { columns, manufUnitPrice } from './columns';

export const ProductQuotesTable = observer(({ productQuotes }) => {
  if (!productQuotes) return null;

  const isIntermediatorMode = clientStore.currentPortal === 'INTERMEDIATOR';
  const finalColumns = [...columns];
  if (isIntermediatorMode) {
    const index = columns.findIndex(col => col.Header === 'Unit Price');
    finalColumns.splice(index, 0, manufUnitPrice);
  }

  return (
    <TableSection
      loading={false}
      columns={finalColumns}
      nodes={productQuotes}
      title='Part Breakdown'
      // RowActionButtons={GetRowActionsButtons(
      //   shipmentQuoteAppManager,
      // )}
      emptyTablePlaceholder={null}
      // Button={button}
    />
  );
});
